import { ThemeProvider } from '@material-ui/core'
import { ConnectedRouter } from 'connected-react-router'
import React from 'react'
import { Provider } from 'react-redux'
import { theme } from '../common/theme'
import history from '../history'
import store from '../store'
import { DialogProvider } from './dialog-provider'
import { FirestoreProvider } from './firestore-provider'

interface IAppProviders {
  children: React.ReactNode
}

export const AppProviders = ({ children }: IAppProviders) => {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <FirestoreProvider>
            <DialogProvider>{children}</DialogProvider>
          </FirestoreProvider>
        </ConnectedRouter>
      </Provider>
    </ThemeProvider>
  )
}
